import { render, staticRenderFns } from "./SpectrumMap.vue?vue&type=template&id=2d405c9c&scoped=true&"
import script from "./SpectrumMap.vue?vue&type=script&lang=js&"
export * from "./SpectrumMap.vue?vue&type=script&lang=js&"
import style0 from "./SpectrumMap.vue?vue&type=style&index=0&id=2d405c9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d405c9c",
  null
  
)

export default component.exports